/**
 * Settings → Orders. Makes hardware order status discoverable without going
 * through the "buy" flow: lists the account's orders (status, delivery,
 * tracking) and links to the order page to buy more.
 */

import { Link } from 'react-router-dom';

import { useOrders } from '@/hooks/useOrders';
import { useAccount } from '@/hooks/useAccount';
import { OrdersList } from '@/components/OrdersList';

export function OrdersSection({ aid }: { aid: string }) {
  const { orders } = useOrders(aid);
  const { account } = useAccount(aid);

  if (orders.length === 0) {
    return (
      <p className="text-sm text-ink-soft">
        No orders yet.{' '}
        <Link
          to={`/accounts/${aid}/order`}
          className="text-accent-700 hover:underline"
        >
          Buy a button →
        </Link>
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <OrdersList orders={orders} elderName={account?.elderName} />
      <p className="text-sm">
        <Link
          to={`/accounts/${aid}/order`}
          className="text-accent-700 hover:underline"
        >
          Buy another button →
        </Link>
      </p>
    </div>
  );
}
